var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.events.length
    ? _c("div", { staticClass: "kit-upcoming-events" }, [
        _c("div", { staticClass: "upcoming-events-block" }, [
          _c("div", { staticClass: "upcoming-events-content" }, [
            _c("h3", [_vm._v("UPCOMING EVENTS")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "upcoming-events-list" },
              _vm._l(_vm.paginatedEvents, function(event, evi) {
                return _c(
                  "a",
                  {
                    key: "evi-" + evi,
                    staticClass: "upcoming-event-item",
                    class: { active: event == _vm.activeEvent },
                    attrs: { href: "#/event/" + event.url_title },
                    on: {
                      mouseenter: function($event) {
                        return _vm.setActiveEvent(event)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "upcoming-dates" }, [
                      _c("div", { staticClass: "date-set" }, [
                        _c("h5", [
                          _vm._v(
                            _vm._s(
                              _vm.printDate(
                                event.dates[0].date,
                                "yyyy-MM-dd",
                                "MMM"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("h4", [
                          _vm._v(
                            _vm._s(
                              _vm.printDate(
                                event.dates[0].date,
                                "yyyy-MM-dd",
                                "dd"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      event.dates.length > 1
                        ? _c("div", { staticClass: "date-separator" }, [
                            _vm._v("-")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      event.dates.length > 1
                        ? _c("div", { staticClass: "date-set" }, [
                            _c("h5", [
                              _vm._v(
                                _vm._s(
                                  _vm.printDate(
                                    event.end.date,
                                    "yyyy-MM-dd",
                                    "MMM"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("h4", [
                              _vm._v(
                                _vm._s(
                                  _vm.printDate(
                                    event.end.date,
                                    "yyyy-MM-dd",
                                    "dd"
                                  )
                                )
                              )
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-content" }, [
                      _c("h3", { domProps: { innerHTML: _vm._s(event.name) } }),
                      _vm._v(" "),
                      _c("h4", {
                        domProps: { innerHTML: _vm._s(event.venue.name) }
                      })
                    ])
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "kit-event-controls" }, [
              _c("div", { staticClass: "kit-pagination" }, [
                _c(
                  "a",
                  {
                    class: { disabled: _vm.page == 0 },
                    on: { click: _vm.prevPage }
                  },
                  [_c("i", { staticClass: "fas fa-angle-left" })]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    class: { disabled: _vm.page == _vm.total_pages - 1 },
                    on: { click: _vm.nextPage }
                  },
                  [_c("i", { staticClass: "fas fa-angle-right" })]
                )
              ]),
              _vm._v(" "),
              _c("a", { staticClass: "view-all", attrs: { href: "/events" } }, [
                _vm._v("VIEW ALL")
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.block.side_block.enabled
            ? _c("div", { staticClass: "upcoming-events-block" }, [
                _c(
                  "a",
                  {
                    staticClass: "side-block-image",
                    attrs: { target: "_blank", href: _vm.block.side_block.link }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.block.side_block.image.sizes.medium_large,
                        alt: "side image"
                      }
                    })
                  ]
                )
              ])
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/KitBlocks/KitEvents.vue?vue&type=template&id=62d22224&
// module id = 546
// module chunks = 0